// pricingService.js
import apiClient from "./apiClient"

const PAYMENT_PATH = "/api/v3/payment"

export const getPricingTableIdByLocation = async (location, recurrence) => {
  try {
    const response = await apiClient.get(`${PAYMENT_PATH}/getPricingTableIdByLocation`, {
      params: { location, recurrence },
    })

    const pricingTableId = response?.data?.data?.pricingTableId
    if (!pricingTableId) {
      throw new Error("pricingTableId not found in API response")
    }

    return pricingTableId
  } catch (error) {
    console.error("getPricingTableIdByLocation failed:", error)
    throw error?.response?.data || error
  }
}

export const getAllPricingData = async (location, recurrence) => {
  try {
    const response = await apiClient.get(`${PAYMENT_PATH}/getAllPricingData`, {
      params: { location, recurrence },
    })

    if (response?.data?.code === 200 && response?.data?.data) {
      return response.data.data
    }

    throw new Error("Invalid response structure")
  } catch (error) {
    console.error("getAllPricingData failed:", error)
    throw error?.response?.data || error
  }
}

export const getPaymentLink = async (priceId) => {
  try {
    const response = await apiClient.get(`${PAYMENT_PATH}/getPaymentLink`, {
      params: { priceId },
    })

    if (response?.data?.code === 200) {
      return response.data.data
    }

    throw new Error(response?.data?.message || "Failed to get payment link")
  } catch (error) {
    console.error("getPaymentLink failed:", error)
    throw error?.response?.data || error
  }
}

export const createCustomerPortal = async () => {
  try {
    const response = await apiClient.get(`${PAYMENT_PATH}/createCustomerPortal`)

    if (response?.data?.code === 200) {
      return response.data.data // { portalLink: "..." }
    }

    // ✅ THROW THE API RESPONSE OBJECT so UI can check .code
    throw response?.data
  } catch (error) {
    console.error("createCustomerPortal failed:", error)
    throw error?.response?.data || error
  }
}

